import { sendRequest } from "../ajax/ajax_es";

/**
 * Dynamický (ajax) filtr platnosti od-do pro ProductCardGrid.
 * Stav (od/do) se drží v data-valid-from / data-valid-to na .next-data-ph a protahuje se
 * do řazení i donačítání (viz appendValidity), takže se filtr neztratí. Žádné parametry v URL stránky.
 */
export function initValidityFilter()
{
    const wrappers = document.getElementsByClassName('product-card-grid-wrapper');

    Array.prototype.forEach.call(wrappers, function (wrapper) {
        const applyButton = wrapper.querySelector('.validity-filter__apply');

        if (!applyButton) {
            return;
        }

        applyButton.addEventListener('click', function () {
            filterByValidity(applyButton, wrapper);
        });
    });
}

function filterByValidity(applyButton, wrapper)
{
    const from = wrapper.querySelector('.validity-filter__from');
    const to = wrapper.querySelector('.validity-filter__to');
    const content = wrapper.getElementsByClassName('next-data-ph')[0];

    if (!content) {
        return;
    }

    // Stav filtru drží .next-data-ph (čte ho řazení i donačítání). Po filtraci začínáme od 1. stránky.
    content.setAttribute('data-valid-from', from ? from.value : '');
    content.setAttribute('data-valid-to', to ? to.value : '');
    content.setAttribute('data-page', '1');

    let url = appendValidity(applyButton.getAttribute('data-link'), content);
    url = appendSort(url, content);

    sendRequest(url, function (xmlhttp) {
        const snippet = Object.values(xmlhttp.response.snippets)[0];
        const grid = wrapper.querySelector('.product-card-grid');
        grid.innerHTML = snippet;

        updateLoadMoreButton(wrapper, grid);
    });
}

/**
 * Šipka "načíst další" (.next-button) je mimo snippet, takže ji redraw filtru neaktualizuje.
 * Po přefiltrování ji srovnáme se stavem gridu stejným signálem jako donačítání: prázdný grid
 * nebo poslední stránka (poslední produkt má .last-detail, když už server nemá další data) => skrýt.
 */
export function updateLoadMoreButton(wrapper, grid)
{
    const button = wrapper.querySelector('.next-button');

    if (!button) {
        return;
    }

    const hasMore = grid.children.length > 0 && grid.querySelector('.last-detail') === null;
    button.style.display = hasMore ? '' : 'none';
}

/**
 * Doplní/nahradí od-do meze (validFrom/validTo) v ajax URL gridu podle data-* na .next-data-ph.
 */
export function appendValidity(url, content)
{
    if (!content || (!content.hasAttribute('data-valid-from') && !content.hasAttribute('data-valid-to'))) {
        return url;
    }

    url = upsertDoParam(url, 'validFrom', content.getAttribute('data-valid-from') || '');
    url = upsertDoParam(url, 'validTo', content.getAttribute('data-valid-to') || '');

    return url;
}

/**
 * Doplní/nahradí řazení (order/column) v ajax URL gridu podle data-* na .next-data-ph.
 */
function appendSort(url, content)
{
    if (!content.hasAttribute('data-order')) {
        return url;
    }

    url = upsertDoParam(url, 'order', content.getAttribute('data-order') || '');
    url = upsertDoParam(url, 'column', content.getAttribute('data-col') || '');

    return url;
}

function upsertDoParam(url, param, value)
{
    // do-namespace komponenty (např. "productCardGrid") z parametru "do=<prefix>-<signal>"
    const match = url.match(/[?&]do=([a-zA-Z]+)-/);

    if (!match) {
        return url;
    }

    const key = match[1] + '-' + param;
    const re = new RegExp('([?&])' + key + '=[^&]*');

    if (re.test(url)) {
        return url.replace(re, '$1' + key + '=' + encodeURIComponent(value));
    }

    return url + '&' + key + '=' + encodeURIComponent(value);
}
